import { createContext, useContext } from "react";

const FormStateContext = createContext();

export const useFormStateContext = () => {
  return useContext(FormStateContext);
};

export default FormStateContext;
